class AnimatedHeadline {
    constructor(element, options = {}) {
        this.element = element;
        this.settings = {
            // Default settings
            animationType: "rotate-1",
            animationDelay: 2500,
            barAnimationDelay: 3800,
            barWaiting: 800,
            lettersDelay: 50,
            typeLettersDelay: 150,
            selectionDuration: 500,
            typeAnimationDelay: 1300,
            revealDuration: 600,
            revealAnimationDelay: 1500,
            ...options
        };

        this.init();
    }

    init() {
        const headline = this.element;
        let duration = this.settings.animationDelay;

        if (this.settings.animationType) {
            // Apply animation type class directly to the headline element
            if (this.settings.animationType === 'type' ||
                this.settings.animationType === 'rotate-2' ||
                this.settings.animationType === 'rotate-3' ||
                this.settings.animationType === 'scale') {
                headline.classList.add('letters', this.settings.animationType);
            } else if (this.settings.animationType === 'clip') {
                headline.classList.add(this.settings.animationType, 'is-full-width');
            } else {
                headline.classList.add(this.settings.animationType);
            }
        }

        this.singleLetters(headline.querySelectorAll('.letters b'));

        if (headline.classList.contains('loading-bar')) {
            duration = this.settings.barAnimationDelay;
            setTimeout(() => {
                headline.querySelector('.cd-words-wrapper').classList.add('is-loading');
            }, this.settings.barWaiting);
        } else if (headline.classList.contains('clip')) {
            const spanWrapper = headline.querySelector('.cd-words-wrapper');
            const newWidth = spanWrapper.offsetWidth + 10;
            spanWrapper.style.width = newWidth + 'px';
        } else if (!headline.classList.contains('type')) {
            // assign to .cd-words-wrapper the width of its longest word
            const words = headline.querySelectorAll('.cd-words-wrapper b');
            let width = 0;
            words.forEach(word => {
                const wordWidth = word.offsetWidth;
                if (wordWidth > width) width = wordWidth;
            });
            const wordsWrapper = headline.querySelector('.cd-words-wrapper');
            if (wordsWrapper) {
                wordsWrapper.style.width = width + 'px';
            }
        }

        // trigger animation
        setTimeout(() => {
            const firstVisibleWord = headline.querySelector('.is-visible');
            if (firstVisibleWord) {
                this.hideWord(firstVisibleWord);
            }
        }, duration);
    }

    singleLetters(words) {
        words.forEach(word => {
            const letters = word.textContent.split('');
            const selected = word.classList.contains('is-visible');

            for (let i = 0; i < letters.length; i++) {
                if (this.hasParentWithClass(word, 'rotate-2')) {
                    letters[i] = '<em>' + letters[i] + '</em>';
                }
                letters[i] = selected ? '<i class="in">' + letters[i] + '</i>' : '<i>' + letters[i] + '</i>';
            }

            const newLetters = letters.join('');
            word.innerHTML = newLetters;
            word.style.opacity = '1';
        });
    }

    hideWord(word) {
        const nextWord = this.takeNext(word);

        if (this.hasParentWithClass(word, 'type')) {
            const parentSpan = word.parentElement;
            parentSpan.classList.add('selected');
            parentSpan.classList.remove('waiting');

            setTimeout(() => {
                parentSpan.classList.remove('selected');
                word.classList.remove('is-visible');
                word.classList.add('is-hidden');
                const iElements = word.querySelectorAll('i');
                iElements.forEach(i => {
                    i.classList.remove('in');
                    i.classList.add('out');
                });
            }, this.settings.selectionDuration);

            setTimeout(() => {
                this.showWord(nextWord, this.settings.typeLettersDelay);
            }, this.settings.typeAnimationDelay);

        } else if (this.hasParentWithClass(word, 'letters')) {
            const bool = (word.querySelectorAll('i').length >= nextWord.querySelectorAll('i').length);
            this.hideLetter(word.querySelector('i'), word, bool, this.settings.lettersDelay);
            this.showLetter(nextWord.querySelector('i'), nextWord, bool, this.settings.lettersDelay);

        } else if (this.hasParentWithClass(word, 'clip')) {
            const wordsWrapper = this.getParentWithClass(word, 'cd-words-wrapper');
            this.animate(wordsWrapper, { width: '2px' }, this.settings.revealDuration, () => {
                this.switchWord(word, nextWord);
                this.showWord(nextWord);
            });

        } else if (this.hasParentWithClass(word, 'loading-bar')) {
            const wordsWrapper = this.getParentWithClass(word, 'cd-words-wrapper');
            wordsWrapper.classList.remove('is-loading');
            this.switchWord(word, nextWord);
            setTimeout(() => this.hideWord(nextWord), this.settings.barAnimationDelay);
            setTimeout(() => wordsWrapper.classList.add('is-loading'), this.settings.barWaiting);

        } else {
            this.switchWord(word, nextWord);
            setTimeout(() => {
                this.hideWord(nextWord);
            }, this.settings.animationDelay);
        }
    }

    showWord(word, duration) {
        if (this.hasParentWithClass(word, 'type')) {
            this.showLetter(word.querySelector('i'), word, false, duration);
            word.classList.add('is-visible');
            word.classList.remove('is-hidden');

        } else if (this.hasParentWithClass(word, 'clip')) {
            const wordsWrapper = this.getParentWithClass(word, 'cd-words-wrapper');
            this.animate(wordsWrapper, { width: (word.offsetWidth + 10) + 'px' }, this.settings.revealDuration, () => {
                setTimeout(() => {
                    this.hideWord(word);
                }, this.settings.revealAnimationDelay);
            });
        }
    }

    hideLetter(letter, word, bool, duration) {
        letter.classList.remove('in');
        letter.classList.add('out');

        if (!this.isLastChild(letter)) {
            setTimeout(() => {
                this.hideLetter(this.getNextSibling(letter), word, bool, duration);
            }, duration);
        } else if (bool) {
            setTimeout(() => {
                this.hideWord(this.takeNext(word));
            }, this.settings.animationDelay);
        }

        if (this.isLastChild(letter) && document.documentElement.classList.contains('no-csstransitions')) {
            const nextWord = this.takeNext(word);
            this.switchWord(word, nextWord);
        }
    }

    showLetter(letter, word, bool, duration) {
        letter.classList.add('in');
        letter.classList.remove('out');

        if (!this.isLastChild(letter)) {
            setTimeout(() => {
                this.showLetter(this.getNextSibling(letter), word, bool, duration);
            }, duration);
        } else {
            if (this.hasParentWithClass(word, 'type')) {
                setTimeout(() => {
                    this.getParentWithClass(word, 'cd-words-wrapper').classList.add('waiting');
                }, 200);
            }
            if (!bool) {
                setTimeout(() => {
                    this.hideWord(word);
                }, this.settings.animationDelay);
            }
        }
    }

    takeNext(word) {
        return !this.isLastChild(word) ? this.getNextSibling(word) : word.parentElement.firstElementChild;
    }

    takePrev(word) {
        return !this.isFirstChild(word) ? this.getPrevSibling(word) : word.parentElement.lastElementChild;
    }

    switchWord(oldWord, newWord) {
        oldWord.classList.remove('is-visible');
        oldWord.classList.add('is-hidden');
        newWord.classList.remove('is-hidden');
        newWord.classList.add('is-visible');
    }

    // Helper methods
    hasParentWithClass(element, className) {
        let parent = element.parentElement;
        while (parent) {
            if (parent.classList && parent.classList.contains(className)) {
                return true;
            }
            parent = parent.parentElement;
        }
        return false;
    }

    getParentWithClass(element, className) {
        let parent = element.parentElement;
        while (parent) {
            if (parent.classList && parent.classList.contains(className)) {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null;
    }

    isLastChild(element) {
        return element === element.parentElement.lastElementChild;
    }

    isFirstChild(element) {
        return element === element.parentElement.firstElementChild;
    }

    getNextSibling(element) {
        return element.nextElementSibling;
    }

    getPrevSibling(element) {
        return element.previousElementSibling;
    }

    // Simple animation helper (replaces jQuery's animate)
    animate(element, properties, duration, callback) {
        const startTime = performance.now();
        const startValues = {};

        // Get initial values
        Object.keys(properties).forEach(prop => {
            if (prop === 'width') {
                startValues[prop] = element.offsetWidth;
            }
        });

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            Object.keys(properties).forEach(prop => {
                if (prop === 'width') {
                    const startValue = startValues[prop];
                    const endValue = parseInt(properties[prop]);
                    const currentValue = startValue + (endValue - startValue) * progress;
                    element.style.width = currentValue + 'px';
                }
            });

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else if (callback) {
                callback();
            }
        };

        requestAnimationFrame(animate);
    }

    // Static method for initializing multiple elements
    static initAll(selector, options = {}) {
        const elements = document.querySelectorAll(selector);
        const instances = [];

        elements.forEach(element => {
            instances.push(new AnimatedHeadline(element, options));
        });

        return instances;
    }
}

export default AnimatedHeadline;